import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

try {
  // Log Firebase project being used and auth state for debugging permission issues
  // eslint-disable-next-line no-console
  console.log('[firebase] initialized projectId=', (firebase.app().options as any).projectId || process.env.REACT_APP_FIREBASE_PROJECT_ID);
  // eslint-disable-next-line no-console
  console.log('[firebase] env REACT_APP_FIREBASE_PROJECT_ID=', process.env.REACT_APP_FIREBASE_PROJECT_ID);
} catch (e) {
  // ignore logging failures in environments where console or options may be restricted
}

export const db = firebase.firestore();

// Debug current auth user if available
if ((firebase as any).auth) {
  try {
    // eslint-disable-next-line no-console
    console.log('[firebase] currentUser=', (firebase as any).auth().currentUser);
  } catch (e) {
    // ignore
  }
}

export default firebase;